import HomePage from './home.jsx';
import TestDescriptionsPage from './test-descriptions.jsx';
import SamplingGuidelinesPage from './sampling-guidelines.jsx';
import FlushingConvertingProcedurePage from './flushing-converting-procedure.jsx';
import ContactPage from './contact.jsx';
import FAQPage from './faq.jsx';
import Navigator from './navigator.jsx';
import LoginPage from './login.jsx';
import RegistrationPage from './register.jsx';
import UserManagementPage from './user-management';
import AccountVerifyPage from './account-verify';
import SubmittedPage from './submitted';
import SampleTrendingPage from './sample-trending';
import DeniedPage from './denied';
import ForgotPasswordPage from './forgot-password';
import PasswordResetPage from './password-reset';
import AccountPage from './account';
import ExternalLoginPage from './external-login';
import SetSecurityPage from './set-security';

export {
    HomePage,
    TestDescriptionsPage,
    SamplingGuidelinesPage,
    FlushingConvertingProcedurePage,
    ContactPage,
    FAQPage,
    Navigator,
    LoginPage,
    RegistrationPage,
    UserManagementPage,
    AccountVerifyPage,
    SubmittedPage,
    SampleTrendingPage,
    DeniedPage,
    ForgotPasswordPage,
    PasswordResetPage,
    AccountPage,
    ExternalLoginPage,
    SetSecurityPage
}



// WEBPACK FOOTER //
// ./web-app/containers/index.js